module.exports = __webpack_public_path__ + "static/img/Caddy.00ea8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Caddy.jpg
// module id = DRHT
// module chunks = 0